<template>
  <v-card :max-width="maxWidth" class="ma-4">
    <v-card-title style="display: flex; justify-content: center">
      {{ mode }}
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      class="mx-5"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1"
      >
        {{ alertValidate }}
      </v-alert>
      <div v-for="(input, i) in inputsForm" :key="'input_' + i + input.name">
        <v-text-field
          :name="input.name"
          v-model="input.data"
          :type="input.type"
          :label="input.label"
          :rules="input.rules"
          outlined
          dense
          :readonly="isReadonly"
        />
      </div>
      <div
        v-for="(select, name) in selects"
        :key="'input_' + name + select.name"
        v-show="show"
      >
        <v-select
          :name="select.name"
          :items="select.items"
          :item-text="select.itemsText"
          :item-value="select.itemsValue"
          v-model="select.data"
          :label="select.label"
          :rules="select.rules"
          outlined
          :multiple="multiple"
          :readonly="isReadonly"
          dense
        />
      </div>
      <div class="d-flex justify-center pb-4">
        <v-btn
          :class="isReadonly ? 'bt-next' : 'bt-exit'"
          @click="toggleEditMode"
        >
          <v-icon>
            {{ isReadonly ? "mdi-pencil" : "mdi-close" }}
          </v-icon>
        </v-btn>
        <v-btn type="submit" class="bt-acept ml-3" v-if="!isReadonly">{{
          $tc("editRegistrations.acept")
        }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Vue from "vue";

export default {
  components: { DateWithCheck, Date },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    multiple: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    readonly: Boolean,
  },
  data() {
    return {
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      isReadonly: false,
    };
  },
  mounted() {
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.isReadonly = Vue.observable(this.readonly);
  },

  methods: {
    submitForm(e) {
      this.isReadonly = !this.isReadonly;
      e.preventDefault();
      this.validation(e.target);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSliderChange(slider) {
      let item = {};
      item[slider.name] = slider.data;

      this.$emit("changeSlider", item);
    },
    toggleEditMode() {
      this.isReadonly = !this.isReadonly;
    },
  },
};
</script>

<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-next {
  background-color: #39537a !important;
  color: white !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
